export function sleep( timeMS:number ):Promise<void>
{
  let promise = new Promise<void>(    
    ( resolve, reject ) =>
    {
      setTimeout( resolve, timeMS );
    }
  );

  return promise;
}